module.exports = __webpack_public_path__ + "img/bg_m.ef809dab.jpg";